module.exports = __webpack_public_path__ + "assets/fonts/Roboto-Light.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/roboto/Roboto-Light.woff
// module id = 685
// module chunks = 0